export default "__VITE_ASSET__MZ_Jm9g$__"